import React from 'react';
import PageOverlay from 'components/PageOverlay';
import PromoPerksContent from './PromoPerksContent';

function PromoPerksPage() {
  return (
    <PageOverlay title="Promo Perks" withExit>
      <PromoPerksContent />
    </PageOverlay>
  );
}

export default PromoPerksPage;
